/* ==========================================================================
 * Brand Casa — Jenny Packham custom PDP interactivity
 * --------------------------------------------------------------------------
 *   - Gallery: thumb click, arrow nav, mobile swipe, hover zoom
 *   - Color swatch: selects color, swaps stage image to variant's featured
 *   - Size: selects size, updates current variant, enables/disables ATC
 *   - Share menu: toggle, Pinterest/email links, copy link
 *   - Accordions: native <details>; animate chevron via CSS
 *   - Size guide modal: open/close with backdrop + Escape
 *   - ATC: AJAX cart/add, then open shared cart drawer (bc-cart-drawer)
 *   - Mobile sticky ATC mirrors desktop state
 * ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-bc-pdp]');
  if (!root) return;

  var variantsNode = root.querySelector('[data-bc-pdp-variants]');
  var VARIANTS = [];
  try { VARIANTS = JSON.parse(variantsNode.textContent || '[]'); } catch (e) {}

  var form = root.querySelector('[data-bc-form]');
  var variantInput = root.querySelector('[data-bc-variant-id]');
  var priceEl = root.querySelector('[data-bc-price]');
  var comparePriceEl = root.querySelector('[data-bc-compare-price]');
  var mobilePriceEl = root.querySelector('[data-bc-mobile-atc-price]');
  var colorNameEl = root.querySelector('[data-bc-color-name]');
  var sizeSummary = root.querySelector('[data-bc-size-summary]');
  var sizeGroup = root.querySelector('[data-bc-size-group]');
  var sizeError = root.querySelector('[data-bc-size-error]');
  var atcBtn = root.querySelector('[data-bc-atc]');
  var atcLabel = root.querySelector('[data-bc-atc-label]');
  var mobileAtcBtn = root.querySelector('[data-bc-mobile-atc-btn]');
  var mobileAtcLabel = root.querySelector('[data-bc-mobile-atc-label]');

  var currentColor = null;
  var currentSize = null;
  var currentVariant = null;

  // Seed selection from pre-selected swatch / select option
  var selSwatch = root.querySelector('.bc-pdp__swatch.is-selected');
  if (selSwatch) currentColor = selSwatch.getAttribute('data-color-value');
  var sizeSelect = root.querySelector('[data-bc-size-select]');
  if (sizeSelect && sizeSelect.value) currentSize = sizeSelect.value;
  currentVariant = findVariant(currentColor, currentSize);

  // Whether this product uses numeric UK sizes (true) or a letter-size scale (false)
  var isNumericSizes = !!(sizeGroup && sizeGroup.getAttribute('data-numeric-sizes') === 'true');

  function findVariant(color, size) {
    return VARIANTS.find(function (v) {
      var colorOk = !color || v.option1 === color;
      var sizeOk = !size || v.option2 === size;
      return colorOk && sizeOk;
    }) || null;
  }

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency, minimumFractionDigits: 2 }).format(cents / 100);
    } catch (e) {
      return '£' + (cents / 100).toFixed(2);
    }
  }

  function updateFromVariant() {
    currentVariant = findVariant(currentColor, currentSize);
    if (currentVariant) {
      variantInput.value = currentVariant.id;
      if (priceEl) priceEl.textContent = money(currentVariant.price);
      if (mobilePriceEl) mobilePriceEl.textContent = money(currentVariant.price);
      // Compare-at-price strikethrough: show only when this variant has a
      // compare_at_price > price. Switching to a non-sale colour hides it.
      if (comparePriceEl) {
        var cap = currentVariant.compare_at_price;
        if (cap && cap > currentVariant.price) {
          comparePriceEl.textContent = money(cap);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.hidden = true;
        }
      }
    }
    // ATC label
    var hasSize = !!currentSize;
    var label = hasSize ? 'Add to Cart' : 'Select a Size';
    var mobileLabel = hasSize ? 'Add to Cart' : 'Select Size';
    if (atcLabel) atcLabel.textContent = label;
    if (mobileAtcLabel) mobileAtcLabel.textContent = mobileLabel;
    atcBtn.classList.toggle('is-nosize', !hasSize);
    if (mobileAtcBtn) mobileAtcBtn.classList.toggle('is-nosize', !hasSize);
  }

  // ─── GALLERY ───────────────────────────────────────────────────────────
  var stage = root.querySelector('[data-bc-stage]');
  var slides = Array.from(root.querySelectorAll('[data-bc-slide]'));
  var thumbs = Array.from(root.querySelectorAll('[data-bc-thumb]'));
  var dots = Array.from(root.querySelectorAll('[data-bc-dot]'));
  var currentSlide = 0;
  var THUMB_LIMIT = 5;

  // Build a map of slide index → list of variant ids it's attached to
  var slideVariantIds = slides.map(function (s) {
    var v = (s.getAttribute('data-variant-ids') || '').trim();
    return v ? v.split(',').map(function (x) { return x.trim(); }) : [];
  });

  function colorKey(colorValue) {
    // "crystal aqua 2144" → "crystalaqua"
    return String(colorValue || '')
      .toLowerCase()
      .replace(/[0-9]+$/g, '')
      .replace(/\s+/g, '')
      .trim();
  }
  function imageSrcOf(idx) {
    var img = slides[idx] && slides[idx].querySelector('img');
    return img ? (img.src || img.getAttribute('src') || '').toLowerCase() : '';
  }
  function slidesForColor(colorValue) {
    if (!colorValue) return slides.map(function (_, i) { return i; });

    // Union of two strategies so we catch both the "featured image" admin
    // attaches to a variant AND the additional gallery shots that share the
    // colour in their filename.
    var matches = new Set();

    // Strategy 1: variant-id attribution (admin linked image→variant)
    var matchingVariantIds = VARIANTS
      .filter(function (v) { return v.option1 === colorValue || v.option2 === colorValue; })
      .map(function (v) { return String(v.id); });
    slideVariantIds.forEach(function (ids, i) {
      if (ids.some(function (id) { return matchingVariantIds.indexOf(id) !== -1; })) matches.add(i);
    });

    // Strategy 2: filename contains the colour key (JP's naming convention)
    var key = colorKey(colorValue);
    if (key) {
      slides.forEach(function (_, i) {
        if (imageSrcOf(i).indexOf(key) !== -1) matches.add(i);
      });
    }

    if (matches.size === 0) return slides.map(function (_, i) { return i; });
    // Return indices in original order
    var out = [];
    slides.forEach(function (_, i) { if (matches.has(i)) out.push(i); });
    return out;
  }

  function filterGalleryByColor(colorValue) {
    var visible = slidesForColor(colorValue);
    var visibleSet = new Set(visible);
    // Thumbs: show first THUMB_LIMIT that match, hide the rest
    var thumbShown = 0;
    thumbs.forEach(function (t, i) {
      var keep = visibleSet.has(i) && thumbShown < THUMB_LIMIT;
      t.hidden = !keep;
      if (keep) thumbShown++;
    });
    // Stage: snap to first matching slide if current isn't in the list
    if (!visibleSet.has(currentSlide)) {
      showSlide(visible[0] != null ? visible[0] : 0);
    }
  }

  function showSlide(i) {
    if (i < 0) i = slides.length - 1;
    if (i >= slides.length) i = 0;
    slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    thumbs.forEach(function (t, idx) {
      t.classList.toggle('is-active', idx === i);
      t.setAttribute('aria-selected', idx === i ? 'true' : 'false');
    });
    dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    currentSlide = i;
    stage.classList.remove('is-zoomed');
  }

  thumbs.forEach(function (t, idx) {
    t.addEventListener('click', function () { showSlide(idx); });
  });
  dots.forEach(function (d, idx) {
    d.addEventListener('click', function () { showSlide(idx); });
  });
  var prevBtn = root.querySelector('[data-bc-prev]');
  var nextBtn = root.querySelector('[data-bc-next]');
  if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); showSlide(currentSlide - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); showSlide(currentSlide + 1); });

  // Swipe on mobile
  var touchStartX = 0;
  stage.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 40) showSlide(dx < 0 ? currentSlide + 1 : currentSlide - 1);
  });

  // Hover zoom (desktop only)
  var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (!isTouchDevice) {
    stage.addEventListener('mouseenter', function () { stage.classList.add('is-zoomed'); });
    stage.addEventListener('mouseleave', function () {
      stage.classList.remove('is-zoomed');
      var activeImg = stage.querySelector('.bc-pdp__slide.is-active img');
      if (activeImg) activeImg.style.transformOrigin = 'center center';
    });
    stage.addEventListener('mousemove', function (e) {
      if (!stage.classList.contains('is-zoomed')) return;
      var rect = stage.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      var activeImg = stage.querySelector('.bc-pdp__slide.is-active img');
      if (activeImg) activeImg.style.transformOrigin = x + '% ' + y + '%';
    });
  }

  // ─── WISHLIST (visual toggle only; wire to backend later) ──────────────
  var wishlistBtn = root.querySelector('[data-bc-wishlist]');
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', function () {
      wishlistBtn.classList.toggle('is-active');
      var svg = wishlistBtn.querySelector('svg');
      if (svg) svg.setAttribute('fill', wishlistBtn.classList.contains('is-active') ? 'currentColor' : 'none');
    });
  }

  // ─── COLOR SWATCHES ────────────────────────────────────────────────────
  root.querySelectorAll('[data-bc-swatch]').forEach(function (sw) {
    sw.addEventListener('click', function () {
      currentColor = sw.getAttribute('data-color-value');
      root.querySelectorAll('[data-bc-swatch]').forEach(function (s) { s.classList.remove('is-selected'); });
      sw.classList.add('is-selected');
      if (colorNameEl) colorNameEl.textContent = sw.getAttribute('data-color-name') || '';

      // Filter thumbs and stage to this colour's images
      filterGalleryByColor(currentColor);

      // Re-check size availability under the new color
      refreshSizeAvailability();
      updateFromVariant();

      // Re-rank the You May Also Like rail so cards reflect the new colour.
      if (root._bcRenderYmal) root._bcRenderYmal();
    });
  });

  function refreshSizeAvailability() {
    if (!sizeSelect) return;
    Array.from(sizeSelect.options).forEach(function (opt) {
      if (!opt.value) return; // skip the placeholder
      var v = findVariant(currentColor, opt.value);
      var available = !!(v && v.available);
      opt.disabled = !available;
      if (v) opt.setAttribute('data-variant-id', v.id);
      // Re-render label so "— Sold Out" stays accurate. Preserve the
      // "· Model wears" marker for the size the model is wearing.
      var uk = opt.getAttribute('data-uk') || '';
      var us = opt.getAttribute('data-us') || '';
      var soldOut = available ? '' : ' — Sold Out';
      var modelWears = opt.getAttribute('data-model-wears') === 'true' ? ' · Model wears' : '';
      if (us) {
        opt.textContent = 'UK Size ' + uk + ' / US Size ' + us + modelWears + soldOut;
      } else {
        opt.textContent = uk + modelWears + soldOut;
      }
    });
  }

  // ─── SIZE SELECT (dropdown) ────────────────────────────────────────────
  if (sizeSelect) {
    sizeSelect.addEventListener('change', function () {
      currentSize = sizeSelect.value || null;
      sizeGroup.classList.remove('is-error');
      if (sizeError) sizeError.hidden = true;
      var opt = sizeSelect.selectedOptions[0];
      if (opt && currentSize) {
        var uk = opt.getAttribute('data-uk') || '';
        var us = opt.getAttribute('data-us') || '';
        if (sizeSummary) {
          sizeSummary.textContent = us
            ? 'UK Size ' + uk + ' / US Size ' + us
            : uk;
        }
      } else if (sizeSummary) {
        sizeSummary.textContent = 'Select a size';
      }
      updateFromVariant();
      // Re-rank YMAL so size-availability boost reflects the new size pick.
      if (root._bcRenderYmal) root._bcRenderYmal();
    });
  }

  // ─── SHARE MENU ────────────────────────────────────────────────────────
  var shareWrap = root.querySelector('[data-bc-share]');
  if (shareWrap) {
    var shareBtn = shareWrap.querySelector('.bc-pdp__share-btn');
    var shareMenu = shareWrap.querySelector('.bc-pdp__share-menu');
    shareBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = shareMenu.getAttribute('data-open') === 'true';
      shareMenu.setAttribute('data-open', !open);
      shareMenu.hidden = open;
      shareBtn.setAttribute('aria-expanded', !open);
    });
    document.addEventListener('click', function () {
      shareMenu.setAttribute('data-open', 'false');
      shareMenu.hidden = true;
      shareBtn.setAttribute('aria-expanded', 'false');
    });
    var copyBtn = shareWrap.querySelector('[data-bc-copy-link]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url = copyBtn.getAttribute('data-url');
        navigator.clipboard && navigator.clipboard.writeText(url).then(function () {
          copyBtn.textContent = 'Copied!';
          setTimeout(function () { copyBtn.textContent = 'Copy Link'; }, 1500);
        });
      });
    }
  }

  // ─── QTY ───────────────────────────────────────────────────────────────
  var qtyInput = root.querySelector('[data-bc-qty-input]');
  root.querySelectorAll('[data-bc-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var delta = parseInt(btn.getAttribute('data-bc-qty'), 10);
      var cur = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, cur + delta);
    });
  });

  // ─── SIZE GUIDE MODAL ──────────────────────────────────────────────────
  var sizeGuide = root.querySelector('[data-bc-sizeguide]');
  function openSizeGuide(e) {
    if (e) e.preventDefault();
    sizeGuide.hidden = false;
    requestAnimationFrame(function () { sizeGuide.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeSizeGuide() {
    sizeGuide.classList.remove('is-open');
    setTimeout(function () { sizeGuide.hidden = true; }, 300);
    document.body.style.overflow = '';
  }
  root.querySelectorAll('[data-bc-sizeguide-open]').forEach(function (el) { el.addEventListener('click', openSizeGuide); });
  sizeGuide.querySelectorAll('[data-bc-sizeguide-close]').forEach(function (el) { el.addEventListener('click', closeSizeGuide); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sizeGuide && !sizeGuide.hidden) closeSizeGuide();
  });

  // ─── ADD TO CART ──────────────────────────────────────────────────────
  function addToCart() {
    if (!currentSize) {
      sizeGroup.classList.add('is-error');
      if (sizeError) sizeError.hidden = false;
      // Scroll size into view on mobile
      if (window.innerWidth < 1000) {
        sizeGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }
    var v = findVariant(currentColor, currentSize);
    if (!v || !v.available) return;

    var qty = parseInt(qtyInput.value, 10) || 1;
    atcBtn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        atcBtn.classList.remove('is-loading');
        document.dispatchEvent(new CustomEvent('cart:update'));
        // Hand off to cart drawer when we ship it; for now open Prestige's.
        if (window.__bcCartDrawerOpen) {
          window.__bcCartDrawerOpen({ variant: v, quantity: qty });
        } else {
          // Fallback: Prestige may expose a cart drawer via x-cart-drawer element
          var drawer = document.querySelector('cart-drawer, x-cart-drawer');
          if (drawer && typeof drawer.show === 'function') drawer.show();
          else window.location.href = '/cart';
        }
      })
      .catch(function () {
        atcBtn.classList.remove('is-loading');
        window.location.href = '/cart';
      });
  }

  form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
  if (mobileAtcBtn) mobileAtcBtn.addEventListener('click', addToCart);

  // ─── YOU MAY ALSO LIKE ─────────────────────────────────────────────────
  var ymalSection = root.querySelector('[data-bc-ymal]');
  var ymalGrid = root.querySelector('[data-bc-ymal-grid]');
  var productId = root.getAttribute('data-product-id');

  function moneyStr(cents) {
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 0 }).format(cents / 100);
    } catch (e) {
      return '£' + Math.round(cents / 100);
    }
  }

  // Enhanced YMAL: rail reflects the colour/size the customer is currently
  // viewing. We fetch a wider pool of related products from Shopify, then
  // score each one against the current variant context:
  //   +5  the product has a variant whose colour matches currentColor
  //   +2  the product has a variant in currentSize that is in stock
  //   +1  the product has at least one in-stock variant in any size
  // Top 4 by score are rendered. When a card matches on colour, the card
  // image, link and price swap to that specific colour variant so the
  // customer sees the rail in the colour they're shopping.
  var ymalCache = null;

  // Normalise a colour name for matching: lowercase, strip whitespace,
  // strip trailing colour-code digits ("Crystal Aqua 2144" -> "crystalaqua").
  function normColor(s) {
    return (s || '').toLowerCase().replace(/[0-9]/g, '').replace(/\s+/g, '').trim();
  }

  function findColorVariant(p, colorVal) {
    if (!colorVal || !p.variants) return null;
    var target = normColor(colorVal);
    if (!target) return null;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      if (normColor(v.option1) === target) return v;
    }
    return null;
  }

  function hasSizeInStock(p, sizeVal) {
    if (!sizeVal || !p.variants) return false;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      if (v.available && (v.option2 === sizeVal || v.option1 === sizeVal)) return true;
    }
    return false;
  }

  function hasAnyStock(p) {
    if (!p.variants) return false;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) return true;
    }
    return false;
  }

  function renderYmal() {
    if (!ymalCache) return;
    var scored = ymalCache.map(function (p) {
      var matched = findColorVariant(p, currentColor);
      var score = 0;
      if (matched) score += 5;
      if (hasSizeInStock(p, currentSize)) score += 2;
      if (hasAnyStock(p)) score += 1;
      return { p: p, score: score, matched: matched };
    });
    scored.sort(function (a, b) { return b.score - a.score; });
    var top = scored.slice(0, 4);

    var html = top.map(function (entry) {
      var p = entry.p;
      var v = entry.matched;
      var img;
      if (v && v.featured_image) {
        img = (v.featured_image && v.featured_image.src) ? v.featured_image.src : v.featured_image;
      } else {
        img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && typeof img === 'object' && img.src) img = img.src;
      }
      var colorOpt = (p.options || []).find(function (o) { return /colou?r/i.test(o.name); });
      var colorCount = colorOpt ? colorOpt.values.length : 0;
      var priceCents = v && v.price != null ? v.price : (p.price != null ? p.price : (p.price_min || 0));
      var baseHref = p.url || '/products/' + p.handle;
      // Shopify's recommendations API sometimes returns p.url with tracking
      // query params already attached (?pr_rec_id=...), so we need to use
      // the right separator when appending the variant.
      var href = baseHref;
      if (v) {
        href += (baseHref.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + v.id;
      }
      return (
        '<a class="bc-pdp__ymal-card" href="' + href + '">' +
          '<div class="bc-pdp__ymal-media">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
            '<button type="button" class="bc-pdp__ymal-wishlist" aria-label="Save to wishlist" onclick="event.preventDefault();event.stopPropagation();this.classList.toggle(\'is-active\');">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>' +
            '</button>' +
          '</div>' +
          '<div class="bc-pdp__ymal-name">' + (p.title || '') + '</div>' +
          '<div class="bc-pdp__ymal-price">' + moneyStr(priceCents) + '</div>' +
          (colorCount > 1 ? '<div class="bc-pdp__ymal-colors">' + colorCount + ' colours available</div>' : '') +
        '</a>'
      );
    }).join('');
    ymalGrid.innerHTML = html;
    ymalSection.hidden = false;
  }

  if (ymalSection && ymalGrid && productId) {
    // Build a wide candidate pool: Shopify recommendations first, then pad
    // with /collections/all/products.json when the API is sparse (happens for
    // newer products that don't have enough order history for ML to draw on).
    // Without the fallback the rail can show just one product or be empty.
    var minCards = 4;

    function fetchRecs(intent) {
      return fetch('/recommendations/products.json?product_id=' + productId + '&limit=12&intent=' + intent, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return j && j.products ? j.products : []; })
        .catch(function () { return []; });
    }

    function fetchCollection(handle) {
      if (!handle) return Promise.resolve([]);
      return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=30', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return j && j.products ? j.products : []; })
        .catch(function () { return []; });
    }

    function fetchAllShuffled() {
      // Pull a wide slice of the catalog then shuffle so each page load gets
      // a different padding set. Without the shuffle the same alphabetical
      // first products (Adeline, Adore, Alexis…) appear on every product
      // page that needs padding, which reads as recommendations being
      // generic and broken.
      return fetch('/collections/all/products.json?limit=100', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var arr = (j && j.products) ? j.products.slice() : [];
          for (var i = arr.length - 1; i > 0; i--) {
            var k = Math.floor(Math.random() * (i + 1));
            var tmp = arr[i]; arr[i] = arr[k]; arr[k] = tmp;
          }
          return arr;
        })
        .catch(function () { return []; });
    }

    function dedupe(products) {
      var seen = {};
      // Exclude the product we're currently viewing.
      seen[productId] = true;
      return products.filter(function (p) {
        var id = String(p.id);
        if (seen[id]) return false;
        seen[id] = true;
        return true;
      });
    }

    var fallbackCollection = ymalSection.getAttribute('data-fallback-collection') || '';

    Promise.all([fetchRecs('related'), fetchRecs('complementary')])
      .then(function (results) {
        var pool = dedupe([].concat(results[0], results[1]));
        if (pool.length >= minCards) return pool;
        // Try the product's own collection next (most relevant padding).
        return fetchCollection(fallbackCollection).then(function (extras) {
          return dedupe(pool.concat(extras));
        });
      })
      .then(function (pool) {
        if (pool.length >= minCards) return pool;
        // Last resort: shuffle the full catalog so each page load looks
        // different rather than always padding with the same alphabetical
        // products.
        return fetchAllShuffled().then(function (extras) {
          return dedupe(pool.concat(extras));
        });
      })
      .then(function (pool) {
        if (!pool.length) return;
        ymalCache = pool;
        renderYmal();
      });
  }

  // Expose renderYmal so the colour swatch and size handlers can re-rank
  // the rail when the customer changes what they're looking at.
  root._bcRenderYmal = renderYmal;

  // ─── DESCRIPTION SHOW MORE / SHOW LESS ────────────────────────────────
  var descToggle = root.querySelector('[data-bc-desc-toggle]');
  if (descToggle) {
    var descPreview = root.querySelector('[data-bc-desc-preview]');
    var descFull = root.querySelector('[data-bc-desc-full]');
    var descToggleLabel = root.querySelector('[data-bc-desc-toggle-label]');
    descToggle.addEventListener('click', function () {
      var open = descToggle.getAttribute('aria-expanded') === 'true';
      descToggle.setAttribute('aria-expanded', !open);
      if (descPreview) descPreview.hidden = !open;
      if (descFull) descFull.hidden = open;
      if (descToggleLabel) descToggleLabel.textContent = open ? 'Show More' : 'Show Less';
    });
  }

  // ─── STICKY MOBILE ATC: show only after the user scrolls PAST the main
  //   ATC button (i.e. the button is above the current viewport). Stays
  //   hidden on landing even though the main ATC is below the fold.
  var mobileAtcEl = root.querySelector('[data-bc-mobile-atc]');
  if (atcBtn && mobileAtcEl) {
    var updateStickyAtc = function () {
      var rect = atcBtn.getBoundingClientRect();
      var show = rect.bottom < 0; // the main ATC has scrolled above the top edge
      mobileAtcEl.classList.toggle('is-visible', show);
      document.body.classList.toggle('bc-mobile-atc-visible', show);
    };
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () { updateStickyAtc(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', updateStickyAtc);
    updateStickyAtc();
  }

  // ─── INIT ──────────────────────────────────────────────────────────────
  refreshSizeAvailability();
  updateFromVariant();
  // Filter gallery to initially selected colour (keeps the left rail tidy)
  filterGalleryByColor(currentColor);
})();
